<template>
  <vue-page-wrapper :title="htmlTitle" :bread-crumbs="breadCrumbs">
    <v-card>
      <vue-card-title
        title="Sales Stage"
        subtitle="Refer to the following information on all the clients."
        :icon="$getIcon('mdiFileChartOutline')"
      >
        <template slot="actions">
          <v-btn
            icon
            class="grey--text ma-0"
            @click="showFilters = !showFilters"
          >
            <v-icon small v-text="$getIcon('mdiFilterVariant')"></v-icon>
          </v-btn>
        </template>
      </vue-card-title>
      <v-divider></v-divider>
      <v-slide-y-transition>
        <v-row v-if="showFilters" class="mx-2" align="center" no-gutters>
          <v-col md="auto" cols="6">
            <vue-auto-complete
              v-model="appliedFilters.service"
              label="Select Service"
              endpoint="api/v1/crm/services/"
              item-text="name"
              item-value="id"
              class="px-2"
            ></vue-auto-complete>
          </v-col>
          <v-col cols="6" md="auto">
            <vue-auto-complete
              v-model="appliedFilters.user"
              label="Select User"
              endpoint="/api/v1/users/autocomplete/?cre_user=True"
              item-text="name"
              item-value="id"
            ></vue-auto-complete>
          </v-col>
          <v-col cols="6" md="3">
            <filter-generator
              v-model="appliedFilters"
              :align-center="false"
              :filters="filters"
            ></filter-generator>
          </v-col>
          <v-col md="auto">
            <v-autocomplete
              v-model="appliedFilters.selectedClient"
              :items="clients"
              label="Search client"
              :search-input.sync="clientSearchQuery"
              item-text="name"
              item-value="id"
              :loading="clientsLoading"
              clearable
            >
            </v-autocomplete>
          </v-col>
          <v-col class="text-center">
            <v-btn small color="primary" dark @click="fetchStat"
              >Apply Filter</v-btn
            >
          </v-col>
        </v-row>
      </v-slide-y-transition>
      <v-data-table
        :headers="headers"
        :items="results"
        :loading="loading"
        class="elevation-1"
        hide-default-footer
        disable-pagination
        mobile-breakpoint="0"
      >
        <template v-slot:item="props">
          <tr>
            <td>
              <a
                class="font-weight-bold"
                @click="(stageInfo = props.item), (dialog = true)"
                >{{ props.item.name }}</a
              >
            </td>
            <td class="text-right">
              <span>{{ getCurrency(props.item.amount) }}</span>
            </td>
            <td class="text-right">{{ props.item.client_count }}</td>
            <td class="text-right">
              <span>{{
                props.item.total_communications === 0
                  ? "-"
                  : props.item.total_communications
              }}</span>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <div>
      <v-dialog v-model="dialog" width="900">
        <sales-stage-detail
          v-if="dialog"
          v-bind="stageInfo"
          :dialog.sync="dialog"
        ></sales-stage-detail>
      </v-dialog>
    </div>
  </vue-page-wrapper>
</template>

<script>
import { getCurrency } from "@/utils/common";
import FilterGenerator from "@/components/common/layout_utils/FilterGenerator";
import cancelRequestMixin from "@/mixins/cancelRequestMixin";
export default {
  components: {
    FilterGenerator,
    SalesStageDetail: () => import("@/components/crm/reports/SalesStageDetail")
  },
  mixins: [cancelRequestMixin],
  created() {
    this.fetchStat();
  },
  data() {
    return {
      htmlTitle: "Sales Stage",
      breadCrumbs: [
        { text: "Reports", disabled: true },
        {
          text: `${this.$store.state.shell.currentOrganizationName}`,
          disabled: true
        }
      ],
      fetchAPI: "api/v1/crm/report/sales-stage/",
      headers: [
        {
          text: "Sales Stage",
          align: "start",
          sortable: false,
          value: "name"
        },
        {
          text: "Amount (NRs)",
          value: "amount",
          sortable: false,
          class: "text-end"
        },
        {
          text: "No. of client",
          value: "client_count",
          sortable: false,
          class: "text-end"
        },
        {
          text: "Communication",
          value: "total_communications",
          sortable: false,
          class: "text-end"
        }
      ],
      filters: [
        {
          component: "vue-date-picker",
          bind: "dateFilter",
          props: { label: "Select Date", default: "All Time" }
        }
      ],
      showFilters: false,
      loading: false,
      appliedFilters: {
        service: null,
        user: null
      },
      creList: [],
      results: [],
      salesStageDetail: [],
      dialog: false,
      stageInfo: {},
      clientSearchQuery: "",
      clients: [],
      clientsLoading: false
    };
  },
  watch: {
    clientSearchQuery: function(newVal) {
      if (newVal?.length > 1) {
        this.getClients();
      }
    }
  },
  methods: {
    getClients() {
      this.clientsLoading = true;
      this.checkRequest();
      this.$axios
        .get(
          `/api/v1/crm/clients/select/?organization__slug=${this.$store.state.shell.currentOrganizationId}`,
          {
            params: {
              search: this.clientSearchQuery
            },
            cancelToken: this.axiosSource.token
          }
        )
        .then(({ data }) => {
          this.clearOldRequest("Success");
          this.clients = data;
          this.clientsLoading = false;
        });
    },
    fetchStat() {
      this.loading = true;
      this.$axios
        .$get(this.fetchAPI, {
          params: {
            service: this.appliedFilters.service,
            user: this.appliedFilters.user,
            start_at:
              (this.appliedFilters.dateFilter &&
                this.appliedFilters.dateFilter.start_date) ||
              null,
            end_at:
              (this.appliedFilters.dateFilter &&
                this.appliedFilters.dateFilter.end_date) ||
              null,
            client: this.appliedFilters.selectedClient || ""
          }
        })
        .then(response => {
          this.results = response;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCurrency
  }
};
</script>
